import {css} from '@emotion/react'
import { PhotoWithIndex } from "type"
import { MouseEvent } from "react"
import { PHOTO_LIST_RESOURCE_URL} from 'config'
import { BiSolidMoviePlay } from 'react-icons/bi'
import { IconContext } from 'react-icons'

type Props = {
  photo: PhotoWithIndex
  onClick?: (event: MouseEvent<HTMLDivElement>, index: number)=>void
}

export const VideoItem = (props: Props) =>{
  const filenameWithoutExtention = props.photo.filename.split('.')[0]

  const onRawClick = (event: MouseEvent<HTMLDivElement>) =>{
    event.stopPropagation()
    if (props.onClick === undefined) return

    props.onClick(event, props.photo.index)
  }

  return(
    <div css={videoContainerCss} onClick={onRawClick}>
      <img
        loading="lazy"
        css={imgCss}
        src={PHOTO_LIST_RESOURCE_URL+'/'+filenameWithoutExtention+'.0000000.jpg'}
        alt="uploaded"
      />
      <div css={iconCss}>
        <IconContext.Provider value={{color: "#fff", size:"1.3rem"}}>
          <BiSolidMoviePlay/>
        </IconContext.Provider>
      </div>
    </div>
  )
}

const videoContainerCss=css`
  position: relative;
  background-color: transparent;
  width: 100%;
  height: 100%;
`

const imgCss = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const iconCss=css`
  position: absolute;
  bottom: 5px;
  right: 5px;
`